import React from 'react';

export const datasetById = (datasets, id) => datasets.find((dataset) => dataset.datasetId === id);

export const formatCompact = (value, digits = 1) => new Intl.NumberFormat('en-US', {
    notation: Math.abs(value) >= 1000 ? 'compact' : 'standard',
    maximumFractionDigits: digits,
}).format(value);

export const MetricCallout = ({ value, label, note }) => (
    <div className="ai-dev-callout">
        <strong>{value}</strong>
        <span>{label}</span>
        {note && <small>{note}</small>}
    </div>
);

export const ChartPanel = ({ eyebrow, title, note, children, className = '' }) => (
    <article className={`ai-dev-panel ${className}`.trim()}>
        {eyebrow && <div className="ai-dev-panel__eyebrow">{eyebrow}</div>}
        <div className="ai-dev-panel__title-row">
            <h3>{title}</h3>
            {note && <span>{note}</span>}
        </div>
        {children}
    </article>
);

export const SnapshotBars = ({ rows, labelKey, valueFormatter = (value) => value, max, color = '#153f78' }) => {
    const resolvedMax = max || Math.max(...rows.map((row) => row.value), 1);
    return (
        <div className="ai-dev-bars">
            {rows.map((row) => (
                <div className="ai-dev-bars__row" key={`${row[labelKey]}-${row.value}`}>
                    <div className="ai-dev-bars__labels"><span>{row[labelKey]}</span><strong>{valueFormatter(row.value, row)}</strong></div>
                    <div className="ai-dev-bars__track"><i style={{ width: `${Math.max(2, (row.value / resolvedMax) * 100)}%`, background: row.color || color }} /></div>
                </div>
            ))}
        </div>
    );
};

export const DataTable = ({ columns, rows, caption }) => (
    <div className="ai-dev-table-wrap">
        <table className="ai-dev-table">
            {caption && <caption>{caption}</caption>}
            <thead><tr>{columns.map((column) => <th key={column.key}>{column.label}</th>)}</tr></thead>
            <tbody>
                {rows.map((row, index) => (
                    <tr key={row.id || `${index}-${row.date || ''}`}>
                        {columns.map((column) => <td key={column.key}>{column.render ? column.render(row) : row[column.key]}</td>)}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export const EmptyNote = ({ children }) => <p className="ai-dev-empty-note">{children}</p>;
